// Diccionarios propios del SDK (sin dependencias) y `t()` con sustitución `{nombre}`.
import { en } from './en.js';
import { es, type MessageKey } from './es.js';
import type { CaptureLocale } from '../types.js';

export type { MessageKey };

export const DICTIONARIES: Record<CaptureLocale, Record<MessageKey, string>> = { es, en };

/** Traductor de un idioma. */
export type Translate = (key: MessageKey, vars?: Record<string, string | number>) => string;

/** Normaliza un idioma a `es` o `en` (por defecto `es`). */
export function normalizeLocale(locale?: string | null): CaptureLocale {
  return locale?.toLowerCase().startsWith('en') ? 'en' : 'es';
}

/** Crea `t()` para un idioma. */
export function translator(locale: CaptureLocale): Translate {
  const dict = DICTIONARIES[locale];
  return (key, vars) =>
    dict[key].replace(/\{(\w+)\}/g, (m, name: string) =>
      vars && name in vars ? String(vars[name]) : m,
    );
}
